import ReactPlayer from 'react-player'
import styled from 'styled-components'
import { Container } from 'components/ListView/VideoImage'

export const VideoWrapper = styled.div`
  position: relative;
  padding-top: 56.25%;
  margin-bottom: 1rem;
  & ${Container} {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`
const StyledPlayer = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  left: 0;
  & iframe {
    width: 100%;
    height: 100%;
  }
`

export default StyledPlayer
